module.exports = __webpack_public_path__ + "img/shows_title.ec8f4ec1.png";